<template>
	<div :style="style" class="avatar-picture"></div>
</template>

<script>
export default {
	computed: {
		picture () {
			return this.$store.getters.getPicture || '/static/img/account-profile-icon.png'
		},
		style () {
			return `background-image:url('${this.picture}')`
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/avatars/AvatarPictureUser.vue